import axiosInstance from "@/api/axiosInstance";
import { StokesResponseDTO } from "@/common/model/dto/response/StokesResponse.dto";
import { StokesAdjustmentRequestDTO } from "@/common/model/dto/request/StokesRequest.dto";
import { StokesTransaction, StokesBalance } from "@/common/model/Stokes";
import { ENDPOINTS } from "@/constants/api";
import { requestHandler } from "@/helpers/requestHandler";

const mapResponseToTransaction = (dto: StokesResponseDTO): StokesTransaction => ({
    id: dto.id,
    userId: dto.userId,
    earnedFromUserId: dto.earnedFromUserId,
    earnedFromUserName: dto.earnedFromUserName,
    earnedFromUserEmail: dto.earnedFromUserEmail,
    earnedFromUserSessionCount: dto.earnedFromUserSessionCount,
    amount: dto.amount,
    reason: dto.reason,
    isEngagement: dto.isEngagement,
    type: dto.type as 'earn' | 'spend',
    date: dto.date,
});

export const StokesService = {
    async fetchByUserId(userId: number): Promise<StokesTransaction[]> {
        return requestHandler<StokesTransaction[]>(async () => {
            const response = await axiosInstance.get(ENDPOINTS.USER_STOKES.GET(userId));
            return response.data.map((dto: StokesResponseDTO) => mapResponseToTransaction(dto));
        }, "StokesService -> fetchByUserId");
    },

    async adjust(adjustment: StokesAdjustmentRequestDTO): Promise<void> {
        return requestHandler<void>(async () => {
            const response = await axiosInstance.post(ENDPOINTS.USER_STOKES.ADJUST, adjustment);
            if (response.data.error) {
                throw new Error(response.data.message);
            }
        }, "StokesService -> adjust");
    },

    calculateBalance(transactions: StokesTransaction[]): StokesBalance {
        let earned = 0;
        let spent = 0;

        transactions.forEach((t) => {
            if (t.type === 'earn') {
                earned += t.amount;
            } else {
                spent += t.amount;
            }
        });

        return {
            total: earned - spent,
            earned,
            spent,
        };
    },
};
